import { ShopCertificate } from 'types/pricing';

export const mockCertificates: ShopCertificate[] = [
  {
    id: '1',
    title: 'Ball Flight 1',
    badgeImageUrl:
      'https://tmgolffilestest.blob.core.windows.net/publicfiles/273e90c0-4068-4549-ac7f-aca8827451b2/Ball_Flight_1_Certificate_badge.png',
    shortDescription: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed.',
    price: 400,
    status: 'completed',
  },
  {
    id: '2',
    title: 'Ball Flight 2',
    badgeImageUrl:
      'https://tmgolffilestest.blob.core.windows.net/publicfiles/876627b8-2bbd-46a2-96af-427ab78c103f/Ball_Flight_2_Certificate_badge.png',
    shortDescription: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed.',
    price: 400,
    status: 'unlocked',
  },
  {
    id: '3',
    title: 'Putting',
    badgeImageUrl:
      'https://tmgolffilestest.blob.core.windows.net/publicfiles/d471f01a-4ecc-4a18-9a4a-0c88bc22f0f9/Performance_Putting_Certificate_badge.png',
    shortDescription: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed.',
    price: 400,
    status: 'locked',
  },
  {
    id: '4',
    title: 'Short Game',
    badgeImageUrl:
      'https://tmgolffilestest.blob.core.windows.net/publicfiles/98533680-bf1d-4b66-8c44-7f0d43356c59/Short_Game_Certificate_badge.png',
    shortDescription: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed.',
    price: 400,
    status: 'owned',
  },
  {
    id: '5',
    title: 'Strokes Gained',
    badgeImageUrl:
      'https://tmgolffilestest.blob.core.windows.net/publicfiles/273e90c0-4068-4549-ac7f-aca8827451b2/Ball_Flight_1_Certificate_badge.png',
    shortDescription: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed.',
    price: 400,
    status: 'completed',
  },
  {
    id: '6',
    title: 'Bio-mechanics',
    badgeImageUrl:
      'https://tmgolffilestest.blob.core.windows.net/publicfiles/f4a1c6a2-21bb-4ee8-aa64-99b2ce5f4a75/Biomechanics_Certificate_badge.png',
    shortDescription: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed.',
    price: 400,
    status: 'unlocked',
  },
];
